import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../components/ui/dropdown-menu";
import { Button } from "../../../components/ui/button";
import { 
  MoreVertical, 
  FileText, 
  Files, 
  Settings, 
  Ban, 
  Trash2,
  Link2,
  Unlink,
  Split
} from "lucide-react";

/**
 * Menu contextuel style Axonaut pour les actions sur une transaction
 */
export function TransactionActionMenu({ 
  transaction, 
  onRapprocher, 
  onRapprochementPartiel,
  onRapprochementAvance,
  onClasserTraite,
  onIgnorer,
  onDelier,
  isRapprochee,
  canMatch
}) {
  const isCredit = transaction.amount > 0;
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="h-8 w-8 p-0 hover:bg-slate-100"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="h-4 w-4 text-slate-500" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {canMatch && (
          <>
            {/* Rapprocher plusieurs factures */}
            <DropdownMenuItem 
              onClick={(e) => { e.stopPropagation(); onRapprocher?.(); }}
              className="cursor-pointer"
            >
              <Files className="mr-3 h-4 w-4 text-blue-500" />
              <span>Rapprocher {isCredit ? 'factures ventes' : 'factures achats'}</span>
            </DropdownMenuItem>

            {/* Facture partiellement payée */}
            <DropdownMenuItem 
              onClick={(e) => { e.stopPropagation(); onRapprochementPartiel?.(); }}
              className="cursor-pointer"
            >
              <Split className="mr-3 h-4 w-4 text-cyan-500" />
              <span>Facture partiellement payée</span>
            </DropdownMenuItem>

            <DropdownMenuSeparator />

            {/* Rapprochement avancé */}
            <DropdownMenuItem 
              onClick={(e) => { e.stopPropagation(); onRapprochementAvance?.(); }}
              className="cursor-pointer"
            >
              <Settings className="mr-3 h-4 w-4 text-slate-700" />
              <span>Rapprochement avancé</span>
            </DropdownMenuItem>

            <DropdownMenuSeparator />

            {/* Déclarer traité */}
            <DropdownMenuItem 
              onClick={(e) => { e.stopPropagation(); onClasserTraite?.(); }}
              className="cursor-pointer"
            >
              <Ban className="mr-3 h-4 w-4 text-orange-500" />
              <span>Déclarer "traité" et ne rien faire</span>
            </DropdownMenuItem>

            {/* Ignorer / Supprimer */}
            <DropdownMenuItem 
              onClick={(e) => { e.stopPropagation(); onIgnorer?.(); }}
              className="cursor-pointer text-slate-500"
            >
              <Trash2 className="mr-3 h-4 w-4" />
              <span>Ignorer</span>
            </DropdownMenuItem>
          </>
        )}

        {isRapprochee && (
          <>
            {/* Ajouter des factures */}
            <DropdownMenuItem 
              onClick={(e) => { e.stopPropagation(); onRapprocher?.(); }}
              className="cursor-pointer"
            >
              <Files className="mr-3 h-4 w-4 text-blue-500" />
              <span>Ajouter des factures</span>
            </DropdownMenuItem>

            <DropdownMenuSeparator />

            {/* Délier */}
            <DropdownMenuItem 
              onClick={(e) => { e.stopPropagation(); onDelier?.(); }}
              className="cursor-pointer text-red-600"
            >
              <Unlink className="mr-3 h-4 w-4" />
              <span>Annuler le rapprochement</span>
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default TransactionActionMenu;
